import React from 'react';
import { services } from '../data/mock';
import {
  Brain, Zap, Bot, MessageCircle, Target,
  Code, Smartphone, Cpu
} from 'lucide-react';

const iconMap = {
  'brain': Brain,
  'zap': Zap,
  'bot': Bot,
  'message-circle': MessageCircle,
  'target': Target,
  'code': Code,
  'smartphone': Smartphone,
  'cpu': Cpu
};

const Services = () => {
  return (
    <section id="services" className="py-16 bg-[#0B0F14] relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-10 space-y-4">
          {/*<h2 className="text-4xl lg:text-5xl font-bold text-white font-['Qurova',sans-serif]">
            Our <span className="text-[#3DF2E0]">AI Solutions</span>
          </h2>*/}
          <h2 className="text-4xl lg:text-5xl font-bold text-white font-['Qurova',sans-serif]">
            Our{" "}
            <span className="relative inline-block text-[#3DF2E0]">
              AI Solutions

              {/* Hand-drawn underline */}
              <svg
                className="absolute left-0 top-full -mt-2"
                width="100%"
                height="22"
                viewBox="0 0 300 22"
                fill="none"
              >
                <path
                  d="M10 14 Q150 2 270 14"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                />

                {/* Dot */}
                <circle cx="285" cy="14" r="4" fill="white" />
              </svg>
            </span>
          </h2>
          {/*<p className="text-xl text-[#9CA3AF] font-['League_Spartan'] max-w-2xl mx-auto">
            Comprehensive AI automation services designed to transform your business operations
          </p>*/}
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                onMouseMove={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = e.clientX - rect.left;
                  const y = e.clientY - rect.top;

                  e.currentTarget.style.setProperty("--x", `${x}px`);
                  e.currentTarget.style.setProperty("--y", `${y}px`);
                }}
                className="group relative overflow-hidden bg-[#0B0F14] border border-[#1F2933] rounded-md p-5 sm:p-6 lg:p-6 cursor-pointer transition-all duration-300 hover:border-[#3DF2E0] hover:-translate-y-2 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(61,242,224,0.35)]"
                style={{
                  boxShadow: '0 0 0 rgba(61, 242, 224, 0)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 0 15px rgba(61, 242, 224, 0.35)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 0 0 rgba(61, 242, 224, 0)';
                }}
              >
                <div className="relative z-10 flex flex-col h-full space-y-4">
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-md border border-[#1F2933] flex items-center justify-center group-hover:border-[#3DF2E0] transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-[#3DF2E0]" />
                  </div>

                  {/* neon glow */}
                  <div
                    className="pointer-events-none absolute -inset-10 rounded-[inherit] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0"
                    style={{
                      background: `radial-gradient(
      600px circle at var(--x) var(--y),
      rgba(61,242,224,0.35) 0%,
      rgba(61,242,224,0.20) 18%,
      rgba(61,242,224,0.10) 35%,
      rgba(61,242,224,0.05) 50%,
      transparent 70%
    )`
                    }}
                  />

                  {/* Content */}
                  <div className="relative z-10 flex flex-col h-full space-y-4">
                    <h3 className="text-xl font-semibold text-white font-['Qurova',sans-serif] group-hover:text-[#3DF2E0] transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-lg text-[#9CA3AF] font-['League_Spartan'] leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
